import Zoomist from 'zoomist';

if (document.querySelector('.zoomist-container')) {
  new Zoomist('.zoomist-container', {
    // Optional parameters
    maxScale: 4,
    bounds: true,
    // if you need slider
    slider: true,
    // if you need zoomer
    zoomer: true,
  });
}
